import { InjectionToken, Provider } from '@angular/core';

export interface AzureADConfig {
  clientId: string;
  tenantId: string;
  redirectUri?: string;
  postLogoutRedirectUri?: string;
}

export interface IMCAuthConfig {
  apiUrl: string;
  azureAD?: AzureADConfig;
  sessionTimeoutMinutes?: number;
  storagePrefix?: string;
  loginRoute?: string;
  unauthorizedRoute?: string;
  requireAdmin?: boolean;
}

export const IMC_AUTH_CONFIG = new InjectionToken<IMCAuthConfig>('IMC_AUTH_CONFIG');

export function provideIMCAuth(config: IMCAuthConfig): Provider[] {
  return [
    { provide: IMC_AUTH_CONFIG, useValue: config }
  ];
}
